module.exports = __webpack_public_path__ + "media/site_templates/www.hirecleaners.com.au/images/our_services_1-fe0b882c1c32645b32a3214515348ac3.jpg";